import { render, staticRenderFns } from "./apartment-search.vue?vue&type=template&id=70fb525c&"
import script from "./apartment-search.ts?vue&type=script&lang=ts&"
export * from "./apartment-search.ts?vue&type=script&lang=ts&"
import style0 from "./apartment-search.scss?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports